// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__zGBaF","menuList":"sidebar_menuList__kh9eg","menuItem":"sidebar_menuItem__ICxeu","active":"sidebar_active__nK3Bu"};